function checkWebp() {
  if (window._webp != undefined) return window._webp;
  try {
    if (
      document
        .createElement('canvas')
        .toDataURL('image/webp')
        .indexOf('data:image/webp') == 0
    )
      window._webp = '.webp';
    else window._webp = '';
  } catch (err) {
    window._webp = '';
  }
  return window._webp || '';
}

export default {
  install(Vue, options) {
    Vue.filter('Price', function(val) {
      return parseInt(val / 10000);
    });

    Vue.filter('getTime', function(val) {
      let day = new Date(val * 1000);
      let y = day.getFullYear();
      let m = day.getMonth() + 1;
      let d = day.getDate();
      return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
    });
    Vue.filter('getTime2', function(val) {
      let day = new Date(val * 1000);
      let y = day.getFullYear();
      let m = day.getMonth() + 1;
      let d = day.getDate();
      let h = day.getHours();
      let min = day.getMinutes();
      return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + (h < 10 ? '0' + h : h) + ':' + (min < 10 ? '0' + min : min) ;
    });
    // int
    Vue.filter('int', function(val) {
      return parseInt(val);
    });
    Vue.filter('imgResize', function(value, type) {
      if (!value && type === 'user') return '//static.house730.com/m/images/user-default.png';
      if (!value && type === 'certificate') return '';
      if (!value) return '//static.house730.com/m/images/house-bg.png';
      const webp = typeof window == 'object' ? checkWebp() : '';
      if (type === 'full') value = value + '?x-oss-process=style/' + '1080xauto_f' + webp;
      else if (type === 'company') value = value + '?x-oss-process=style/' + '360x270_c' + webp;
      else if (type === 'user') value = value + '?x-oss-process=style/' + '150xauto_f' + webp;
      else value = value + '?x-oss-process=style/' + '640x480_c' + webp;
      return value;
    });
  }
};
